import { getTokenWithEmail } from '../../common/constant';
import App_data from '../../views/config/App_data';
import FD from '../../views/RestAPI/fetchData';

export const fetchCartItem = (data = {}) => {
  return FD.callAPI(App_data.backend_api + '/checkout_v1/getCart', {
    ...data,
    ...getTokenWithEmail(),
  });
};

export const updateSelectedExam = (data = {}) => {
  return FD.callAPI(App_data.backend_api + '/user/updateExamSelected', {
    ...data,
    ...getTokenWithEmail(),
  });
};



// WEBPACK FOOTER //
// ./src/components/Header/service.js